exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel-control[_v-e0565696] {\n  cursor: pointer;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-e0565696&file=Carousel.vue&scoped=true!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Carousel.vue
// module id = 114
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Carousel.vue?370e